import { render, staticRenderFns } from "./Capitalaccount.vue?vue&type=template&id=d2f98a96&scoped=true"
import script from "./Capitalaccount.vue?vue&type=script&lang=js"
export * from "./Capitalaccount.vue?vue&type=script&lang=js"
import style0 from "./Capitalaccount.vue?vue&type=style&index=0&id=d2f98a96&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2f98a96",
  null
  
)

export default component.exports